export * from './synergy-config.interface';
export * from './synergy-config-test.interface';